// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".topic-description[data-v-7cbcad4e]{white-space:pre-line}.gender-portal-header[data-v-7cbcad4e]{flex:0 0 auto;display:flex;align-items:flex-start}.topic-logo[data-v-7cbcad4e]{width:85px;margin-right:24px}.m-block__links[data-v-7cbcad4e]{overflow-y:auto;padding:0 12px 12px 12px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
